'use client';

import { ProductDetailInfoCTA, ProductDetailSelectorMenu, ProductType } from '@headless-workspace/domain/common/client';
import {
    CapacityFormat,
    ProductDetailVariantValue,
    ProductSetItemValue,
} from '@headless-workspace/domain/common/server';
import { GlowIcon, GlowSelector, Icons, PropsWithFontFamily, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductSetList } from './ProductSetList';

export type VariantSelectorProps = PropsWithLocale &
    PropsWithFontFamily & {
        sku: string;
        variants: ProductDetailVariantValue[];
        formats: CapacityFormat[];
        currency: string;
        enableDiscountInfo?: boolean;
        priceAlwaysBlack: boolean;
        squaredShade: boolean;
        isVipBrand: boolean;
        type: ProductType;
        productsSetList?: ProductSetItemValue[];
    };

export const VariantSelector: Component<VariantSelectorProps> = ({
    type,
    sku,
    variants,
    formats,
    currency,
    enableDiscountInfo,
    priceAlwaysBlack,
    isVipBrand,
    squaredShade,
    locale,
    fontFamily,
    productsSetList,
}) => {
    if (type === ProductType.PRODUCT_SET) {
        return (
            <ProductSetList
                productsList={productsSetList}
                fontFamily={fontFamily}
                priceAlwaysBlack={priceAlwaysBlack}
                isVipBrand={isVipBrand}
                squaredShade={squaredShade}
            />
        );
    }

    const imgShapeClassName =
        (type === ProductType.MULTI_SKU_SHADE_UNI || type === ProductType.MULTI_SKU_SHADE_DIFF) && !squaredShade
            ? 'rounded-infinity'
            : '';

    const buttonElement = (openMenu: () => void) => {
        const hasMultipleVariants = variants.length > 1;
        const RightElement = hasMultipleVariants ? <GlowIcon Icon={Icons.ChevronRight} type={'medium'} /> : null;
        const onClick = hasMultipleVariants ? openMenu : undefined;

        // FIXME: Use the correct variant when variant selection behavior is implemented
        const { thumbnailImage: variantImage, name: variantName } = variants[0];
        return (
            <GlowSelector
                image={variantImage}
                imageClassName={imgShapeClassName}
                titleContent={{
                    label: variantName,
                    fontWeight: 'bold',
                }}
                RightElement={RightElement}
                onClick={onClick}
                fontFamily={fontFamily}
            />
        );
    };

    return (
        <ProductDetailInfoCTA
            menu={
                <ProductDetailSelectorMenu
                    key={sku}
                    type={type}
                    formats={formats}
                    variants={variants}
                    locale={locale}
                    currency={currency}
                    fontFamily={fontFamily}
                    enableDiscountInfo={enableDiscountInfo}
                    priceAlwaysBlack={priceAlwaysBlack}
                    squaredShade={squaredShade}
                    productDefaultSku={sku}
                />
            }
            buttonElement={buttonElement}
        />
    );
};
